import CSS from "csstype";

export const BodyContainerStyle:CSS.Properties={
    paddingTop:'0',
    paddingBottom:'0',
    marginTop:'0'
};

export const WideBodyContainerStyle:CSS.Properties={
    padding:'0',
    margin:'0',
    maxWidth:'100%'
};

export const MainContainerStyle:CSS.Properties = {
    padding:'0',
    maxWidth:'100%',
};

export const HeaderContainerStyle:CSS.Properties = {
    paddingBottom:'0',
};